<template>
  <ZapiModalShell
    v-model:visible="mostrarModal"
    width="450px"
    title="Canal de Venta Detalle"
    :loading="enviado"
    @confirm="guardarCanal"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <span>
            <strong>NOMBRE: </strong>
            <span class="p-invalid">*</span>
          </span>
          <InputText
            v-model.trim="data_canal.nombre"
            required="true"
            autofocus
            :class="{ 'p-invalid': errors.nombre }"
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre
          }}</small>
        </div>

        <div class="field col-12 md:col-12" v-if="data_canal.id">
          <span>
            <strong>ESTADO: </strong>
            <span class="p-invalid">*</span>
          </span>
          <Dropdown
            v-model="data_canal.estado"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span v-if="slotProps.value" :class="'product-badge ' + claseEstado[slotProps.value.value]">
                {{ slotProps.value.label }}
              </span>
            </template>
            <template #option="slotProps">
              <span :class="'product-badge ' + claseEstado[slotProps.option.value]">
                {{ slotProps.option.label }}
              </span>
            </template>
          </Dropdown>
        </div>

        <div class="field col-12 md:col-12">
          <span>
            <strong>MÉTODOS DE PAGO: </strong>
          </span>
          <SelectMetodoPago
            v-model="data_canal.metodo_pago_ids"
            :multiple="true"
          />
        </div>
      </div>
    </div>
    
    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start">
          <strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span>
        </span>
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        :label="data_canal.id ? 'ACTUALIZAR' : 'GUARDAR'"
        :icon="data_canal.id ? 'pi pi-pencil' : 'pi pi-save'"
        class="p-button-info p-button-lg"
        @click="guardarCanal"
        :loading="enviado"
      />
    </template>
  </ZapiModalShell>
</template>

<script>
import CanalVentaService from "@/service/CanalVentaService";
import ZapiModalShell from "@/components/shared/ZapiModalShell.vue";
import SelectMetodoPago from "@/components/shared/SelectMetodoPago.vue";

export default {
  components: {
    ZapiModalShell,
    SelectMetodoPago
  },
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    canal: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  canalVentaService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_canal: { ...this.canal, metodo_pago_ids: [] },
      enviado: false,
      estados: [
        { label: "Inactivo", value: 0 },
        { label: "Activo", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
    };
  },
  created() {
    this.canalVentaService = new CanalVentaService();
  },
  methods: {
    ocultarDialog() {
      this.errors = {};
      this.$emit("closeModal");
      this.enviado = false;
    },
    validarFormulario() {
      this.errors = {};
      if (!this.data_canal.nombre || this.data_canal.nombre.trim() === "") {
        this.errors.nombre = "El nombre es obligatorio.";
      }
      return Object.keys(this.errors).length === 0;
    },
    guardarCanal() {
      if (!this.validarFormulario()) return;

      this.enviado = true;
      let payload = {
        nombre: this.data_canal.nombre,
        estado: this.data_canal.estado ? this.data_canal.estado.value : 1,
        metodo_pago_ids: this.data_canal.metodo_pago_ids || []
      };

      if (this.data_canal.id) {
        this.canalVentaService.updateCanalVenta(this.data_canal.id, payload).then((data) => {
          if (data.status === true) {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: data.message,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.mostrarModal = false;
          } else {
            this.errors = data.errors || {};
          }
          this.enviado = false;
        }).catch(() => { this.enviado = false; });
      } else {
        this.canalVentaService.crearCanalVenta(payload).then((data) => {
          if (data.status === true) {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: data.message,
              life: 3000,
            });
            this.$emit("actualizarListado", data.canalventa);
            this.ocultarDialog();
          } else {
            this.errors = data.errors || {};
          }
          this.enviado = false;
        }).catch(() => { this.enviado = false; });
      }
    },
  },
  watch: {
    mostrarModal(val) {
      if (!val) {
        this.ocultarDialog();
      }
    },
    show(val) {
      this.mostrarModal = val;
    },
    canal: {
      handler(val) {
        this.data_canal = { ...val };
        // Si no tiene estado (es nuevo), inicializarlo
        if (!this.data_canal.id) {
          this.data_canal.estado = { label: "Activo", value: 1 };
          this.data_canal.metodo_pago_ids = [];
        } else {
          if (typeof this.data_canal.estado === 'number') {
            // Convertir de número a objeto estado para el Dropdown
            this.data_canal.estado = this.estados.find(e => e.value === this.data_canal.estado);
          }
          // Extraer los IDs de los métodos de pago asociados si existen
          if (this.data_canal.metodos_pago && Array.isArray(this.data_canal.metodos_pago)) {
            this.data_canal.metodo_pago_ids = this.data_canal.metodos_pago.map(m => m.id);
          } else {
            this.data_canal.metodo_pago_ids = [];
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
